import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Checkbox} from "../../classes/checkbox";

@Component({
    selector: 'app-weave-checkbox-group',
    templateUrl: './weave-checkbox-group.component.html',
    styleUrls: ['./weave-checkbox-group.component.scss'],
    standalone: false
})
export class WeaveCheckboxGroupComponent implements OnInit {

  @Input() label: string;
  @Input() checkboxList: Checkbox[];
  @Input() required: boolean;
  @Input() initialData: string[] = [];
  @Input() showError: boolean = false;
  @Output() changed: EventEmitter<string[]> = new EventEmitter<string[]>();
  checkboxListState: Checkbox[] = [];

  message: string = "";

  constructor() {
  }

  ngOnInit(): void {
    this.message = this.label;
    if (!this.message || this.message.length > 30) {
      this.message = "This field";
    }

    this.initiateCheckboxGroup();
  }

  initiateCheckboxGroup() {
    if (!this.initialData) {
      this.initialData = [];
    }

    this.checkboxListState = [];
    this.checkboxList.forEach(checkbox => {
      const tmpCheckbox: Checkbox = {
        data: this.initialData.includes(checkbox.value),
        value: checkbox.value,
        label: checkbox.label
      };

      this.checkboxListState.push(tmpCheckbox);
    });
  }

  onChange(checkboxValue: string) {
    const checkBoxIndex = this.checkboxListState.findIndex((checkbox: Checkbox) => checkbox.value == checkboxValue);
    this.checkboxListState[checkBoxIndex].data = !this.checkboxListState[checkBoxIndex].data;

    // If checked added in data table else remove it
    if (this.checkboxListState[checkBoxIndex].data) {
      this.initialData.push(checkboxValue);
    } else {
      this.initialData = this.initialData.filter(value => value != checkboxValue);
    }

    this.changed.emit(this.initialData);
  }

}
